import { drawTemplateComposition } from './templateCompositions';
const backgrounds = new Map();
export function validTemplateDimensions(width, height) { return Number.isInteger(Number(width)) && Number.isInteger(Number(height)) && Number(width) >= 32 && Number(height) >= 32 && Number(width) <= 4096 && Number(height) <= 4096; }
function backgroundImage(path) {
  if (!backgrounds.has(path)) backgrounds.set(path, new Promise((resolve, reject) => { const image = new Image(); image.onload = () => resolve(image); image.onerror = () => reject(new Error('The template background could not be loaded. Please try again.')); image.src = `${process.env.PUBLIC_URL || ''}${path}`; }).catch((error) => { backgrounds.delete(path); throw error; }));
  return backgrounds.get(path);
}
function wrapText(ctx, value, width) {
  const lines = [];
  for (const paragraph of String(value).split('\n')) {
    let line = '';
    for (const word of paragraph.split(/\s+/)) {
      if (ctx.measureText(word).width > width) {
        if (line) { lines.push(line); line = ''; }
        let fragment = '';
        for (const character of word) { if (fragment && ctx.measureText(fragment + character).width > width) { lines.push(fragment); fragment = ''; } fragment += character; }
        line = fragment;
      } else if (line && ctx.measureText(`${line} ${word}`).width > width) { lines.push(line); line = word; }
      else line = line ? `${line} ${word}` : word;
    }
    lines.push(line);
  }
  return lines;
}
export async function drawStaticTemplate(canvas, template, values, width, height, photoOverride) {
  if (!validTemplateDimensions(width, height)) throw new Error('Use whole-number dimensions between 32 and 4096 pixels.');
  const background = await backgroundImage(template.background);
  canvas.width = Number(width); canvas.height = Number(height);
  const ctx = canvas.getContext('2d'), w = canvas.width, h = canvas.height;
  ctx.drawImage(background, 0, 0, w, h);
  if (photoOverride || template.photoBackground) {
    const photo = photoOverride || await backgroundImage(template.photoBackground);
    drawTemplateComposition(ctx, photo, template, w, h);
  }
  const format = w / h > 3 ? 'banner' : w / h < .9 ? 'portrait' : 'landscape';
  for (const field of template.fields) {
    const value = String(values[field.id] || '');
    if (!value.trim()) continue;
    const box = field.positions[format], x = box.x * w, y = box.y * h, bw = box.width * w, bh = box.height * h;
    let fontSize = Math.max(1, Math.min(w, h) * field.fontSizes[format]), lines = [];
    for (; fontSize > 1; fontSize = Math.max(1, fontSize - Math.max(.5, fontSize * .035))) {
      ctx.font = `${field.weight || 'normal'} ${fontSize}px ${field.fontFamily || 'Arial'}`;
      lines = wrapText(ctx, value, bw);
      if (lines.length * fontSize * 1.2 <= bh) break;
    }
    ctx.font = `${field.weight || 'normal'} ${fontSize}px ${field.fontFamily || 'Arial'}`;
    lines = wrapText(ctx, value, bw);
    ctx.save(); ctx.beginPath(); ctx.rect(x, y, bw, bh); ctx.clip();
    ctx.fillStyle = field.color; ctx.textBaseline = 'top'; ctx.textAlign = field.align || 'left';
    const textX = field.align === 'center' ? x + bw / 2 : field.align === 'right' ? x + bw : x;
    const textY = y + Math.max(0, (bh - lines.length * fontSize * 1.2) / 2);
    lines.forEach((line, index) => ctx.fillText(line, textX, textY + index * fontSize * 1.2));
    ctx.restore();
  }
}
